// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"8b328f16","522":"3adeb821","887":"3adeb821","918":"4aa051ad"}[chunkId] + ".chunk.css";
};